var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 18 12" }, props),
    React.createElement("path", { d: "M6.5 7.458c-1.95 0-5.833.975-5.833 2.917v1.458h11.666v-1.458c0-1.942-3.883-2.917-5.833-2.917zm-3.883 2.708c.7-.483 2.391-1.041 3.883-1.041s3.183.558 3.883 1.041H2.617zM6.5 6a2.92 2.92 0 0 0 2.917-2.917A2.92 2.92 0 0 0 6.5.167a2.92 2.92 0 0 0-2.917 2.916A2.92 2.92 0 0 0 6.5 6zm0-4.167c.692 0 1.25.559 1.25 1.25 0 .692-.558 1.25-1.25 1.25s-1.25-.558-1.25-1.25.558-1.25 1.25-1.25zm5.867 5.675c.966.7 1.633 1.634 1.633 2.867v1.458h3.333v-1.458c0-1.684-2.916-2.642-4.966-2.867zM11.5 6a2.92 2.92 0 0 0 2.917-2.917A2.92 2.92 0 0 0 11.5.167c-.45 0-.867.108-1.25.291.525.742.833 1.65.833 2.625 0 .975-.308 1.883-.833 2.625.383.183.8.292 1.25.292z" })
  );
});